import __request__ from "routing/request";
export function reportAvailability(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/summary/availability", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function investigationReport(investigationId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/summary/${investigationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
